<template>
    <modal name="login" class="dd-m-modal dd-m-modal--auth">
        <button v-on:click="hide()" type="button" class="dd-m-auth__close-btn">
            <i class="dd-m-icon icon-close"></i>
        </button>

        <auth-login></auth-login>
    </modal>
</template>
<script>
    import AuthLogin from "./auth-login";
    const queryString = require('query-string');

    export default {
        name: 'modal-login',
        components: {AuthLogin},
        props: ['name'],
        mounted() {
            PubSub.subscribe('openLoginModal', () => this.show());

            PubSub.subscribe('closeLoginModal', (msg, hasCallback) => {
                this.hide();
                PubSub.publish('loginModalCallback', hasCallback);
            });

            this.checkOpenModal();
        },
        methods: {
            show() {
                this.$modal.show('login');
            },
            hide() {
                this.$modal.hide('login');
            },
            checkOpenModal() {
            	return false;
                const parsed = queryString.parse(location.search);
                if (parsed.sign) {
                    setTimeout(() => {
                        this.show();
                    }, 100);
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/site/js/components/auth/modal-login.vue